<template>
  <div>
  <v-toolbar id="core-toolbar" flat prominent style="background: #eee;">
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn v-if="responsive" class="default v-btn--simple" dark icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer/>
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-text-field
          v-if="responsiveInput"
          class="mr-4 mt-2 purple-input"
          label="Search..."
          hide-details
          color="purple"
        />
        <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
          <router-link v-ripple slot="activator" class="toolbar-items" to="/notifications">
            <v-badge color="error" overlap>
              <v-icon color="tertiary">mdi-plus-circle</v-icon>
            </v-badge>
          </router-link>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="notification in notifications"
                :key="notification"
                @click="onClick"
              >
                <v-list-tile-title v-text="notification"/>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
         <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon color="tertiary">mdi-web</v-icon>
              </v-btn>
            </template>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="language in languages"
                :key="language.title"
                @click="changeLocale(language.language)"
              >
                <v-list-tile-title v-text="language.title"/>
                <flag :iso="language.flag" v-bind:squared="false"/>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <router-link v-ripple class="toolbar-items" to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link>
        <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
          <router-link v-ripple slot="activator" class="toolbar-items" to="/notifications">
            <v-badge color="error" overlap>
              <template slot="badge">{{ notifications.length }}</template>
              <v-icon color="tertiary">mdi-bell</v-icon>
            </v-badge>
          </router-link>
          <v-card>
            <v-list dense>
              <v-list-tile
                v-for="notification in notifications"
                :key="notification"
                @click="onClick"
              >
                <v-list-tile-title v-text="notification"/>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
        <router-link v-ripple class="toolbar-items" to="/logout">
          <v-icon color="tertiary">mdi-exit-run</v-icon>{{name}}
        </router-link>
      </v-flex>
    </v-toolbar-items>

  </v-toolbar>

        <core-menu></core-menu>
  </div>

</template>

<script>
import { mapMutations } from "vuex";
import Menu from "./Menu"

import i18n from "@/i18n";
import auth from '@/auth'

export default {
  data: () => ({
    name:auth.getName(),
    components:{'core-menu':Menu},
    notifications: [
      "Mike, John responded to your email",
      "You have 5 new tasks",
      "You're now a friend with Andrew",
      "Another Notification",
      "Another One"
    ],
    title: null,
    responsive: false,
    responsiveInput: false,
    languages: [
      { flag: "us", language: "en", title: "English" },
      { flag: "es", language: "es", title: "Español" }
    ]
  }),

  watch: {
    $route(val) {
      this.title = val.name;
    }
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    changeLocale(locale) {
      i18n.locale = locale;
      //$store.commit("changeLanguage",{ lang: this.selectedLang, i18n: this.$i18n })
      //  window.location.reload()
    }
  }
};
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
</style>

/* TODO 
Save language to store
*/